import { render, staticRenderFns } from "./TabClearingHouse.vue?vue&type=template&id=c410428a&scoped=true&"
import script from "./TabClearingHouse.vue?vue&type=script&lang=js&"
export * from "./TabClearingHouse.vue?vue&type=script&lang=js&"
import style0 from "./TabClearingHouse.vue?vue&type=style&index=0&id=c410428a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c410428a",
  null
  
)

export default component.exports